import Afiche from "./Afiche"

const Year = (props: any) : JSX.Element => {
  return <Afiche />
}

export default Year